import { HeaderGrid, HeaderLogo, HeaderStyled } from './Header.style'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'
import { Link } from 'react-router'
import { HashLink } from 'app/App.components/HashLink/HashLink.view'
import { State } from 'utils/interfaces'
import { LIGHT_THEME } from '../../../redux/actions/preferences.action'
import { ThemeToggle } from '../ToggleButton/ThemeToggle.controller'

export const HeaderView = () => {
  const darkThemeEnabled = useSelector((state: State) => state.preferences.themeSelected !== LIGHT_THEME)

  const isLitepaperPage = window.location.pathname === '/litepaper'

  /**
   * handle scroll for desktop (parallax)
   */
  const [scrollPositionDesktop, setScrollPositionDesktop] = useState(0)
  const handleScroll = () => {
    setScrollPositionDesktop(window.pageYOffset)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  /**
   * handle scroll for mobile (Pure CSS)
   */
  const scrollPositionMobile = useSelector((state: any) => state.preferences.scrollPosition)

  // const logoUrl = darkThemeEnabled || (!darkThemeEnabled && !isLitepaperPage && scrollPositionMobile < 800 && scrollPositionDesktop < 900) ? "/logo-dark.svg" : "/logo-light.svg";
  const showBg = scrollPositionMobile > 800 || scrollPositionDesktop > 900 || isLitepaperPage

  const logoUrl = darkThemeEnabled ? '/logo-dark.svg' : '/logo-light.svg'
  const topColor = darkThemeEnabled ? 'rgb(22, 14, 63)' : '#6598c9'
  const showBbColor = darkThemeEnabled ? 'rgb(8, 6, 40)' : 'rgb(235, 240, 255)'
  const browserColor = showBg ? showBbColor : topColor

  return (
    <HeaderStyled $showBg={showBg}>
      <Helmet>
        <meta name="theme-color" content={browserColor} />
      </Helmet>
      <HeaderGrid $showBg={showBg}>
        <Link to="/">
          <HeaderLogo $showBg={showBg} $src={logoUrl} />
        </Link>

        <Link to="/litepaper">Litepaper</Link>
        {/*<Link to="/liquidity-baking">{isMobile ? 'LB' : 'Liquidity Baking'}</Link>*/}
        {/*<Link to="/bakery">{isSmallMobile ? <Icon id='bakery' /> : isMobile ? 'Bakeries' : 'Maven Bakeries'}</Link>*/}

        <HashLink
          to="/#calculator"
          scroll={(el) =>
            window.scrollTo({
              behavior: 'smooth',
              top: el.getBoundingClientRect().top + window.pageYOffset - 124,
            })
          }
        >
          Calculator
        </HashLink>
        <HashLink
          to="/#features"
          scroll={(el) =>
            window.scrollTo({
              behavior: 'smooth',
              top: el.getBoundingClientRect().top + window.pageYOffset - 74,
            })
          }
        >
          Features
        </HashLink>
        <HashLink
          to="/#tokenomics"
          scroll={(el) =>
            window.scrollTo({
              behavior: 'smooth',
              top: el.getBoundingClientRect().top + window.pageYOffset - 60,
            })
          }
        >
          Tokenomics
        </HashLink>
        <HashLink
          to="/#satellites"
          scroll={(el) =>
            window.scrollTo({
              behavior: 'smooth',
              top: el.getBoundingClientRect().top + window.pageYOffset - 124,
            })
          }
        >
          Satellites
        </HashLink>
        <a href="https://blog.mavenfinance.io/" target="_blank" rel="noreferrer">
          Blog
        </a>
        <ThemeToggle />
      </HeaderGrid>
    </HeaderStyled>
  )
}
